import axios from "axios";
import { qs } from "../utils/common.util";
const { REACT_APP_API_URL } = process.env;

export const customerRegisterService = async (customer) => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/add`, {
      customer: customer,
    });
  } catch (err) {
    return {
      error: true,
      errMsg: err.response?.data?.message,
    };
  }
};

export const customerGetService = async (_id) => {
  try {
    return await axios.get(`${REACT_APP_API_URL}/customer/get/${_id}`);
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerGetDataSheetService = async (_id) => {
  try {
    return await axios.get(`${REACT_APP_API_URL}/customer/getdata/${_id}`);
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerGetMembersService = async (_id) => {
  try {
    return await axios.get(`${REACT_APP_API_URL}/customer/members/${_id}`);
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerAddMemberService = async (member) => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/members/new`, {
      member: member,
    });
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerUpdateMemberService = async (id, member) => {
  try {
    return await axios.patch(
      `${REACT_APP_API_URL}/customer/members/update/${id}`,
      {
        member: member,
      },
    );
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerDeleteMemberService = async (id) => {
  try {
    return await axios.delete(
      `${REACT_APP_API_URL}/customer/members/delete/${id}`,
    );
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerUpdateService = async (customer) => {
  try {
    return await axios.patch(`${REACT_APP_API_URL}/customer/update`, customer);
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerUpdateDataService = async (customerDataSheet) => {
  try {
    return await axios.patch(
      `${REACT_APP_API_URL}/customer/updatedata`,
      customerDataSheet,
    );
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerVerifyService = async (id) => {
  try {
    return await axios.patch(`${REACT_APP_API_URL}/customer/verify/${id}`);
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

// export const customerGetInvoicesService = async (customerId) => {
//   try {
//     return await axios.get(
//       `${REACT_APP_API_URL}/customer/invoices/${customerId}`,
//     );
//   } catch (err) {
//     return {
//       error: true,
//       errMsg: err.message,
//     };
//   }
// };

export const customerGetAlertsService = async (customerId, status) => {
  try {
    let url = `${REACT_APP_API_URL}/alerts/${customerId}`;
    if (status !== undefined) url += "?status=" + status;
    return await axios.get(url);
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const customerSolveAlertService = async (customerId, alertId) => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/alerts/solve`, {
      customerId: customerId,
      alertId: alertId,
    });
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const resetPasswordService = async (customer) => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/reset`, customer);
  } catch (err) {
    return {
      error: true,
      response: err.response?.data?.message,
    };
  }
};

// export const customerGetAlertCountsService = async (customerId) => {
//   try {
//     return await axios.get(`${REACT_APP_API_URL}/alerts/count/${customerId}`);
//   } catch (err) {
//     return {
//       error: true,
//       errMsg: err.message,
//     };
//   }
// };

export const updateDeleteCustomer = async (data) => {
  try {
    return await axios.patch(
      `${REACT_APP_API_URL}/customer/delete?${qs(data)}`,
    );
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const deactivateSubscriptionService = async (data) => {
  try {
    return await axios.patch(
      `${REACT_APP_API_URL}/customer/cancelsubscription`,
      data,
    );
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
      err: err.response?.data?.message,
    };
  }
};

export const validateEmailId = async (emailId) => {
  try {
    return await axios.get(`${REACT_APP_API_URL}/customer/email/${emailId}`);
  } catch (err) {
    return {
      error: true,
      errMsg: err.message,
    };
  }
};

export const checkForPrivacyGiftRedeem = async (id) => {
  try {
    return await axios.get(`${REACT_APP_API_URL}/customer/gift/redeem/${id}`);
  } catch (err) {
    return {
      error: true,
      errMsg: err.response?.data?.message,
    };
  }
};

export const privacyGiftRedeem = async (data) => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/gift/redeem`, data);
  } catch (err) {
    return {
      error: true,
      errMsg: err?.response?.data?.message,
    };
  }
};

export const deleteCustomerDataService = async (data) => {
  try {
    return await axios.post(
      `${REACT_APP_API_URL}/deleteAccountRequests/add`,
      data,
    );
  } catch (err) {
    return {
      error: true,
      response: err.message,
    };
  }
};
